// utils/checkoutHelpers.js

/**
 * Generates a unique request ID for tracking API calls
 * Uses crypto.randomUUID() when available, falls back to timestamp + random string
 * @returns {string} Unique request identifier
 */
export const generateRequestId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return 'req_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

/**
 * The amount the payment step shows and, for wallet payments, charges.
 *
 * The tip is chosen on the payment step (#484), so the tip snapshot stored on
 * the order at creation (`checkoutDetails.tipAmount`) is stale by definition.
 * Only the Clover order total (which includes tax) plus the LIVE tip counts —
 * the same two inputs payOrder charges with for card payments.
 *
 * @param {object|null} orderResponse - createOrder response
 * @param {number} [tipAmount=0] - live tip in cents from CheckoutContext
 * @returns {number} cents
 */
export const amountToCharge = (orderResponse, tipAmount = 0) => {
  const orderTotal = orderResponse?.order?.total || 0;
  if (!orderTotal) return 0;
  return orderTotal + (tipAmount || 0);
};
